import React from "react";
import { format } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { DateRange } from "react-day-picker";
import { useDataPicker } from "./hooks";

export function DatePickerWithRange({
  className,
}: React.HTMLAttributes<HTMLDivElement>) {
  const {
    date,
    setDate,
    onTodayClick,
    onYesterdayClick,
    onThisWeekClick,
    onThisMonthClick,
    onLastMonthClick,
    storageKey,
    getButtonVariant,
  } = useDataPicker();

  return (
    <div className={cn("grid gap-2", className)}>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            id="date"
            variant={"outline"}
            className={cn(
              "w-[300px] justify-start text-left font-normal",
              !date?.from && "text-muted-foreground"
            )}
          >
            <CalendarIcon />
            {date?.from ? (
              date.to ? (
                <>
                  {format(date.from, "LLL dd, y")} -{" "}
                  {format(date.to, "LLL dd, y")}
                </>
              ) : (
                format(date.from, "LLL dd, y")
              )
            ) : (
              <span>Pick a date</span>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            initialFocus
            mode="range"
            defaultMonth={date?.from}
            selected={date}
            onSelect={(range) => setDate(range as DateRange, storageKey)}
            numberOfMonths={2}
          />
          <div className="w-full flex flex-col gap-2 px-4 py-3">
            <div className="grid grid-cols-2 gap-2">
              <Button
                variant={getButtonVariant("lastMonth")}
                size="sm"
                onClick={onLastMonthClick}
              >
                Last month
              </Button>
              <Button
                variant={getButtonVariant("thisMonth")}
                size="sm"
                onClick={onThisMonthClick}
              >
                This month
              </Button>
              <Button
                variant={getButtonVariant("thisWeek")}
                size="sm"
                onClick={onThisWeekClick}
              >
                This week
              </Button>
              <Button
                variant={getButtonVariant("yesterday")}
                size="sm"
                onClick={onYesterdayClick}
              >
                Yesterday
              </Button>
              <Button
                variant={getButtonVariant("today")}
                size="sm"
                className="col-span-2"
                onClick={onTodayClick}
              >
                Today
              </Button>
            </div>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
}
